/* VELLIE — custom-product.js (vanilla, no dependencies, ~7 KB minified).
   Each section includes this file with `defer`; the guard below makes it run once.
   All prices/labels come pre-formatted from Liquid (Shopify Markets currency + translations). */
(function () {
  'use strict';
  if (window.VELLIE) return;
  window.VELLIE = {};

  var mqMobile = window.matchMedia('(max-width: 749px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var once = function (el, key) { if (el['__lk' + key]) return false; el['__lk' + key] = true; return true; };

  /* ---------------- Video (lazy, desktop/mobile source, autoplay muted) ---------------- */
  var videoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var wrap = e.target, v = wrap.querySelector('video');
      if (!v) return;
      if (e.isIntersecting) {
        loadSrc(v);
        if (wrap.dataset.autoplay === 'true' && !reduceMotion.matches) playSafe(wrap, v);
      } else if (!v.paused && wrap.dataset.autoplay === 'true') {
        v.pause(); wrap.classList.remove('is-playing');
      }
    });
  }, { rootMargin: '250px 0px' }) : null;

  function loadSrc(v) {
    if (v.dataset.loaded) return;
    var src = (mqMobile.matches && v.dataset.srcM) ? v.dataset.srcM : v.dataset.srcD;
    if (!src) return;
    v.src = src; v.dataset.loaded = '1'; v.preload = 'metadata';
  }
  function playSafe(wrap, v) {
    var p = v.play();
    wrap.classList.add('is-playing');
    if (p && p.catch) p.catch(function () { wrap.classList.remove('is-playing'); });
  }
  function initVideos(root) {
    $$('[data-lk-video]', root).forEach(function (wrap) {
      if (!once(wrap, 'v')) return;
      var v = wrap.querySelector('video');
      if (!v) return;
      if (wrap.dataset.eager === 'true' || !videoIO) {
        loadSrc(v);
        if (wrap.dataset.autoplay === 'true' && !reduceMotion.matches) playSafe(wrap, v);
      }
      if (videoIO) videoIO.observe(wrap);
      var play = wrap.querySelector('[data-lk-play]');
      if (play) play.addEventListener('click', function () { loadSrc(v); v.controls = true; playSafe(wrap, v); });
      var sound = wrap.querySelector('[data-lk-sound]');
      if (sound) sound.addEventListener('click', function () {
        loadSrc(v); v.muted = !v.muted; wrap.classList.toggle('is-unmuted', !v.muted);
        if (v.paused) playSafe(wrap, v);
      });
    });
  }

  /* ---------------- Generic scroll-snap helpers ---------------- */
  function step(track, dir) {
    var item = track.firstElementChild;
    var w = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    track.scrollBy({ left: dir * w, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }
  function initCarousels(root) {
    $$('[data-lk-carousel]', root).forEach(function (c) {
      if (!once(c, 'c')) return;
      var t = c.querySelector('[data-lk-car-track]'), prev = c.querySelector('[data-lk-car-prev]'), next = c.querySelector('[data-lk-car-next]');
      var sync = function () {
        if (prev) prev.disabled = t.scrollLeft < 4;
        if (next) next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      };
      if (prev) prev.addEventListener('click', function () { step(t, -1); });
      if (next) next.addEventListener('click', function () { step(t, 1); });
      t.addEventListener('scroll', sync, { passive: true }); sync();
    });
    $$('[data-lk-quote]', root).forEach(function (q) {
      if (!once(q, 'q')) return;
      var t = q.querySelector('[data-lk-quote-track]');
      var go = function (d) {
        var max = t.scrollWidth - t.clientWidth;
        if (d > 0 && t.scrollLeft >= max - 4) t.scrollTo({ left: 0, behavior: 'smooth' }); else step(t, d);
      };
      q.querySelector('[data-lk-quote-prev]').addEventListener('click', function () { go(-1); });
      q.querySelector('[data-lk-quote-next]').addEventListener('click', function () { go(1); });
      if (t.children.length < 2) $$('.lk-quote__nav', q).forEach(function (b) { b.hidden = true; });
    });
  }

  /* ---------------- Product hero: gallery, variants, quantity ---------------- */
  function initProducts(root) {
    $$('[data-lk-product]', root).forEach(function (sec) {
      if (!once(sec, 'p')) return;
      var dataEl = sec.querySelector('[data-lk-variants]');
      var i18nEl = sec.querySelector('[data-lk-i18n]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var i18n = i18nEl ? JSON.parse(i18nEl.textContent) : {};
      var track = sec.querySelector('[data-lk-gal-track]');
      var thumbs = $$('[data-lk-thumb]', sec);
      var fieldsets = $$('[data-lk-option]', sec);
      var idInput = sec.querySelector('[data-lk-variant-id]');
      var atc = sec.querySelector('[data-lk-atc]');
      var atcLabel = sec.querySelector('[data-lk-atc-label]');
      var qtyInput = sec.querySelector('[data-lk-qty-input]');
      var priceEl = sec.querySelector('[data-lk-price]');
      var compareEl = sec.querySelector('[data-lk-compare]');
      var saveEl = sec.querySelector('[data-lk-save]');
      var saveWrap = sec.querySelector('[data-save-format]');
      var saveFormat = saveWrap ? saveWrap.dataset.saveFormat : 'percent';

      /* gallery */
      if (track) {
        var slides = $$('[data-lk-slide]', track);
        var goTo = function (i) { var s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' }); };
        var prev = sec.querySelector('[data-lk-gal-prev]'), next = sec.querySelector('[data-lk-gal-next]');
        if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
        if (prev) prev.addEventListener('click', function () { step(track, -1); });
        if (next) next.addEventListener('click', function () { step(track, 1); });
        thumbs.forEach(function (b) { b.addEventListener('click', function () { goTo(+b.dataset.lkThumb); }); });
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return; ticking = true;
          requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / track.clientWidth);
            thumbs.forEach(function (b) { b.classList.toggle('is-active', +b.dataset.lkThumb === i); });
            $$('video', track).forEach(function (v) { if (!v.closest('[data-lk-video]') && !v.paused) v.pause(); });
            ticking = false;
          });
        }, { passive: true });
        sec.__lkGoMedia = function (mediaId) {
          var s = track.querySelector('[data-media-id="' + mediaId + '"]');
          if (s) goTo(slides.indexOf(s));
        };
      }

      /* quantity */
      $$('[data-lk-qty]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          qtyInput.value = Math.max(1, Math.min(99, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.lkQty, 10)));
        });
      });

      /* variants */
      if (!fieldsets.length) return;
      var current = variants.filter(function (x) { return idInput && String(x.id) === idInput.value; })[0] || variants[0];
      var selected = function () {
        var opts = current.options.slice();
        fieldsets.forEach(function (fs) { var c = fs.querySelector('input:checked'); if (c) opts[+fs.dataset.lkOption] = c.value; });
        return opts;
      };
      var matches = function (v, opts) { return v.options.every(function (o, i) { return o === opts[i]; }); };
      var markAvailability = function (opts) {
        fieldsets.forEach(function (fs) {
          var i = +fs.dataset.lkOption;
          var lbl = fs.querySelector('[data-lk-selected]'); if (lbl) lbl.textContent = opts[i] || '';
          $$('input', fs).forEach(function (input) {
            var test = opts.slice(); test[i] = input.value;
            input.classList.toggle('is-off', !variants.some(function (v) { return v.available && matches(v, test); }));
          });
        });
      };
      var update = function () {
        var opts = selected();
        markAvailability(opts);
        var v = variants.filter(function (x) { return matches(x, opts); })[0];
        if (atc) atc.disabled = !(v && v.available);
        if (atcLabel) atcLabel.textContent = !v ? i18n.unavailable : (v.available ? i18n.add : i18n.soldout);
        if (!v) return;
        current = v;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) { compareEl.hidden = !v.compare; if (v.compare) compareEl.textContent = v.compare; }
        if (saveEl) {
          var txt = saveFormat === 'amount' ? v.save_amt : v.save_pct;
          saveEl.hidden = !txt; if (txt) saveEl.textContent = txt;
        }
        if (v.media && sec.__lkGoMedia) sec.__lkGoMedia(v.media);
        if (history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          history.replaceState(null, '', url.toString());
        }
        document.dispatchEvent(new CustomEvent('lk:variant', { detail: { productId: sec.dataset.productId, variant: v } }));
      };
      sec.addEventListener('change', function (e) { if (e.target.closest('[data-lk-option]')) update(); });
      markAvailability(selected());
    });
  }

  /* ---------------- Sticky add to cart ---------------- */
  function initSticky(root) {
    $$('[data-lk-sticky]', root).forEach(function (bar) {
      if (!once(bar, 's')) return;
      var pid = bar.dataset.productId;
      var hero = document.querySelector('[data-lk-product][data-product-id="' + pid + '"]');
      var heroForm = hero && hero.querySelector('form[data-lk-form]');
      var heroAtc = hero && hero.querySelector('[data-lk-atc]');
      var form = bar.querySelector('[data-lk-sticky-form]');
      var priceEl = bar.querySelector('[data-lk-sticky-price]');
      var btn = bar.querySelector('[data-lk-sticky-btn]');
      var vInput = bar.querySelector('[data-lk-sticky-variant]');
      var show = function (on) { bar.classList.toggle('is-visible', on); bar.toggleAttribute('inert', !on); };
      if (bar.dataset.mode === 'always' || !heroAtc || !('IntersectionObserver' in window)) {
        show(true);
      } else {
        show(false);
        new IntersectionObserver(function (en) { var e = en[0]; show(!e.isIntersecting && e.boundingClientRect.top < 0); }).observe(heroAtc);
      }
      document.addEventListener('lk:variant', function (e) {
        if (String(e.detail.productId) !== String(pid)) return;
        var v = e.detail.variant;
        if (priceEl) priceEl.textContent = v.price;
        if (vInput) vInput.value = v.id;
        if (btn) btn.disabled = !v.available;
      });
      if (form && heroForm) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (heroForm.requestSubmit) heroForm.requestSubmit(); else heroForm.submit();
        });
      }
    });
  }

  /* ---------------- Reviews "show more" ---------------- */
  function initReviews(root) {
    $$('[data-lk-more]', root).forEach(function (b) {
      if (!once(b, 'm')) return;
      b.addEventListener('click', function () {
        var sec = b.closest('.lk-sec');
        $$('[data-lk-more-item][hidden]', sec).slice(0, 8).forEach(function (r) { r.hidden = false; });
        if (!sec.querySelector('[data-lk-more-item][hidden]')) b.parentNode.hidden = true;
      });
    });
  }

  /* ---------------- Announcement rotation + localization form ---------------- */
  function initBar(root) {
    $$('[data-lk-bar]', root).forEach(function (bar) {
      if (!once(bar, 'b')) return;
      var msgs = $$('.lk-bar__msg', bar);
      if (msgs.length > 1 && !reduceMotion.matches) {
        var i = 0, ms = (parseInt(bar.dataset.interval, 10) || 5) * 1000;
        setInterval(function () {
          if (document.hidden) return;
          msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
        }, ms);
      }
      $$('[data-lk-loc-select]', bar).forEach(function (sel) {
        sel.addEventListener('change', function () { var f = sel.form; if (f.requestSubmit) f.requestSubmit(); else f.submit(); });
      });
    });
  }

  function init(root) {
    root = root || document;
    initVideos(root); initCarousels(root); initProducts(root); initSticky(root); initReviews(root); initBar(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  /* Theme editor: re-init a section after it is edited */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('.lk-car__item, .lk-quote__slide');
    if (slide && slide.scrollIntoView) slide.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
})();
